export default function Profile() {
  return <div>Thông tin cá nhân</div>;
}

export {};
